import cn from 'classnames';
import { NavLink } from 'react-router-dom';
import { ROOM } from '@consts/blackjack';
import { IModule } from '@api/types/general';
import { TMaxPlayers, TRoomSlug } from '@api/types/blackjack';
import { ReactComponent as ArrowIcon } from '@assets/svg/arrow.svg';
import { ReactComponent as CoinIcon } from '@assets/svg/coin.svg';
import CountdownTimer from '@components/countdown-timer';
import InfoCard from '@components/info-card';
import useReduxState from '@hooks/useReduxState';
import styles from './heading.module.scss';
import FairnessBadge from '../components/fairness-badge';

const NAV_ITEMS = ['Game', 'History', 'How to play'];
const MAX_PLAYERS: number = 2;

const TableHeading = ({ className = '' }: IModule): JSX.Element => {
  const [chatState] = useReduxState((state) => state.chat);

  /* Components */

  const NavItems = NAV_ITEMS.map((item, idx) => (
    <NavLink
      key={item}
      to={`/games/blackjack/game/2aaf3`}
      className={cn(styles.navigation__link, { [styles.active]: idx === 0 })}
    >
      {item}
    </NavLink>
  ));

  /* ClassNames */

  const roomColor: TRoomSlug = ROOM.COLORS[MAX_PLAYERS as TMaxPlayers];

  const getRoomColorClasses = (className: string): string =>
    cn(styles[className], {
      [styles[`${className}-color-${roomColor}`]]: roomColor,
    });

  const containerClasses: string = cn(styles.heading, className, {
    [styles.chatIsVisible]: !chatState.collapsed,
  });
  const dataContainerClasses: string = getRoomColorClasses('data');
  const roomNameClasses: string = getRoomColorClasses('room__name');
  const roomPlayersClasses: string = getRoomColorClasses('room__players');
  const goBackBtnClasses: string = cn(styles.data__goBack, {
    [styles[`data__goBack-fill-${roomColor}`]]: roomColor,
  });

  return (
    <header className={containerClasses}>
      <section className={dataContainerClasses}>
        <button type="button" className={goBackBtnClasses}>
          <ArrowIcon />
        </button>
        <div className={styles.room}>
          <h1 className={roomNameClasses}>Miami Room</h1>
          <p className={roomPlayersClasses}>2/2 Players</p>
        </div>
      </section>
      <section className={styles.aboutGame}>
        <nav className={styles.navigation}>{NavItems}</nav>
        <div className={styles.info}>
          <FairnessBadge text="4% fee" className={styles.info__badge} />
          <CountdownTimer
            seconds={25}
            start={false}
            className={styles.info__countdown}
          />
        </div>
      </section>
      <section className={styles.gameFee}>
        <InfoCard
          text="2.20"
          icon={<CoinIcon />}
          color="black-gradient"
          className={styles.gameFee__cost}
        />
      </section>
    </header>
  );
};

export default TableHeading;
